import React from 'react';

import FluxosProaq from './FluxosProaq';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import { getSubAbas } from '../subabas';

const FluxosProaqIndex: React.FC = () => {
  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />
      <FluxosProaq />
    </>
  );
};

export default FluxosProaqIndex;
